(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_nanovit-hero-buy"] && !Shopify.designMode) return;
  try {
    (function () {
    function initBis(root) {
      if (!root || root.dataset.bisBound) return;
      root.dataset.bisBound = '1';

      var openBtn = root.querySelector('[data-bis-open]');
      var formWrap = root.querySelector('[data-bis-form]');
      var formEl = formWrap && formWrap.querySelector('.pdp__bis-formel');
      if (!openBtn || !formWrap || !formEl) return;

      // volta do captcha (/challenge): o return_to marca a URL com ?bis-posted=1
      if (window.location.search.indexOf('bis-posted=1') !== -1) {
        openBtn.hidden = true;
        formWrap.hidden = false;
        formWrap.innerHTML = '<p class="pdp__bis-success">' + (formWrap.getAttribute('data-success') || 'Pronto! Vamos te avisar quando voltar.') + '</p>';
        try { window.history.replaceState(null, '', window.location.pathname); } catch (err) {}
        return;
      }

      openBtn.addEventListener('click', function () {
        formWrap.hidden = false;
        openBtn.hidden = true;
        var input = formEl.querySelector('input[type="email"]');
        if (input) input.focus();
      });

      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = formEl.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        var oldErr = formWrap.querySelector('.pdp__bis-error');
        if (oldErr) oldErr.parentNode.removeChild(oldErr);
        fetch(formEl.action, { method: 'POST', body: new FormData(formEl), headers: { Accept: 'text/html' } })
          .then(function (r) { return { url: r.url || '', redirected: !!r.redirected }; })
          .then(function (res) {
            if (res.url.indexOf('/challenge') !== -1) {
              // Shopify pediu captcha: submit nativo para o cliente resolver;
              // a volta cai na PDP com ?bis-posted=1 e o sucesso aparece no load.
              formEl.submit();
              return;
            }
            if (res.redirected || res.url.indexOf('customer_posted=true') !== -1 || res.url.indexOf('posted=true') !== -1) {
              var msg = formWrap.getAttribute('data-success') || 'Pronto! Vamos te avisar quando voltar.';
              formWrap.innerHTML = '<p class="pdp__bis-success">' + msg + '</p>';
            } else {
              // resposta ambígua (200 sem redirect, ex.: bot-protection ou e-mail
              // já cadastrado): reenvia nativo em vez de mostrar erro. O POST é
              // idempotente (mesma tag) e a volta cai em ?bis-posted=1 com sucesso.
              formEl.submit();
            }
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            var p = document.createElement('p');
            p.className = 'pdp__bis-error';
            p.textContent = 'Não foi possível cadastrar agora. Tente de novo.';
            formEl.appendChild(p);
          });
      });
    }

    function initAll() { document.querySelectorAll('[data-pdp-bis]').forEach(initBis); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
